$(document).ready(function () {

    $('.js-has-children').on('click', function (e){

        e.preventDefault(); //Stop from redirecting to link

        $(this).closest('.js-nav-link').find('.js-sub-menu').toggleClass('active');

    });

    $('.js-mobile-nav-icon').on('click', function (){

        $(this).toggleClass('active');
        $('.js-mobile-nav-items').toggleClass('active');

    });

});